package com.daytimegaming.ourdailyfinances.data.network.service

import com.daytimegaming.ourdailyfinances.data.network.ApiClient
import com.daytimegaming.ourdailyfinances.data.network.dto.BudgetDto
import com.daytimegaming.ourdailyfinances.data.network.dto.BudgetListResponse
import com.daytimegaming.ourdailyfinances.data.network.dto.CreateBudgetRequest
import com.daytimegaming.ourdailyfinances.data.network.dto.UpdateBudgetRequest
import com.daytimegaming.ourdailyfinances.data.network.dto.MessageResponse
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.patch
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

class BudgetService(private val apiClient: ApiClient) {
    suspend fun getBudgets(): BudgetListResponse =
        apiClient.http.get("${apiClient.baseUrl}/budgets").body()

    suspend fun createBudget(
        name: String,
        categories: List<String>,
        targetValue: Double,
        dashboardIds: List<String>?
    ): BudgetDto =
        apiClient.http.post("${apiClient.baseUrl}/budgets") {
            contentType(ContentType.Application.Json)
            setBody(CreateBudgetRequest(name, categories, targetValue, dashboardIds))
        }.body()

    suspend fun updateBudget(
        budgetId: String,
        name: String?,
        categories: List<String>?,
        targetValue: Double?,
        dashboardIds: List<String>?
    ): BudgetDto =
        apiClient.http.patch("${apiClient.baseUrl}/budgets/$budgetId") {
            contentType(ContentType.Application.Json)
            setBody(UpdateBudgetRequest(name, categories, targetValue, dashboardIds))
        }.body()

    suspend fun deleteBudget(budgetId: String): MessageResponse =
        apiClient.http.delete("${apiClient.baseUrl}/budgets/$budgetId").body()
}
